{
  "appliances": [
    { "id": "rice-cooker", "label": "Nồi cơm điện" },
    { "id": "oven", "label": "Lò nướng" },
    { "id": "blender", "label": "Máy xay" }
  ],
  "mealTypes": [
    { "id": "breakfast", "label": "Bữa sáng" },
    { "id": "main", "label": "Món chính" },
    { "id": "snack", "label": "Ăn nhẹ" },
    { "id": "drink", "label": "Đồ uống" },
    { "id": "side", "label": "Món ăn kèm" }
  ],
  "recipes": [
    {
      "slug": "com-ga-nam", "title": "Cơm gà nấm", "summary": "Cơm mềm thơm, thịt gà và nấm hòa quyện trong một bữa ăn ấm bụng, dễ chuẩn bị.",
      "image": "/recipe-images/com-ga-nam.png", "imageAlt": "Bát cơm gà nấm với hành lá trên khăn vải màu kem", "illustrative": true,
      "appliance": "rice-cooker", "mealType": "main", "prepMinutes": 15, "cookMinutes": 35, "servings": 2,
      "ingredients": [
        { "amount": "200 g", "name": "gạo" }, { "amount": "250 g", "name": "thịt gà lọc xương" }, { "amount": "100 g", "name": "nấm hương tươi" },
        { "amount": "1 thìa canh", "name": "nước tương" }, { "amount": "1 thìa cà phê", "name": "dầu mè" }, { "amount": "Một ít", "name": "gừng, hành lá, muối" }
      ],
      "steps": [
        "Vo gạo. Làm sạch nấm, thái lát. Thái gà thành miếng nhỏ và ướp với nước tương, dầu mè, gừng trong 10 phút.",
        "Cho gạo vào nồi cơm điện, thêm lượng nước theo hướng dẫn của loại gạo và thiết bị. Xếp gà và nấm lên trên, không nén chặt.",
        "Chọn chế độ nấu cơm phù hợp theo hướng dẫn thiết bị. Sau khi hoàn tất, kiểm tra gà chín hoàn toàn; nếu cần, tiếp tục làm chín trước khi dùng.",
        "Để cơm nghỉ vài phút, xới nhẹ, thêm hành lá và nêm vừa miệng. Dùng khi còn nóng."
      ],
      "tips": ["Thái gà đều miếng để chín đồng đều.", "Lượng nước và thời gian nấu cần điều chỉnh theo loại gạo và hướng dẫn nồi cơm điện."]
    },
    {
      "slug": "ca-hoi-nuong-chanh", "title": "Cá hồi nướng chanh", "summary": "Cá hồi nướng mềm, thơm vị chanh và thảo mộc, dùng cùng rau xanh cho bữa tối gọn nhẹ.",
      "image": "/recipe-images/ca-hoi-nuong-chanh.png", "imageAlt": "Cá hồi nướng với chanh và rau xanh trên đĩa sứ", "illustrative": true,
      "appliance": "oven", "mealType": "main", "prepMinutes": 10, "cookMinutes": 18, "servings": 2,
      "ingredients": [
        { "amount": "2 miếng", "name": "phi lê cá hồi, khoảng 150 g mỗi miếng" }, { "amount": "1 quả", "name": "chanh vàng" }, { "amount": "1 thìa canh", "name": "dầu ô liu" },
        { "amount": "1 tép", "name": "tỏi băm" }, { "amount": "150 g", "name": "măng tây" }, { "amount": "Một ít", "name": "muối, tiêu, thì là" }
      ],
      "steps": [
        "Làm nóng lò ở 190°C nếu thiết bị cho phép. Thấm khô cá và rửa sạch măng tây.",
        "Trộn dầu ô liu, tỏi, muối và tiêu. Thoa lên cá, xếp chanh thái lát và thì là lên trên.",
        "Đặt cá và măng tây lên khay phù hợp. Nướng khoảng 15–18 phút, điều chỉnh theo độ dày của cá và hướng dẫn lò.",
        "Kiểm tra phần giữa cá chín hoàn toàn, thịt cá tách lớp dễ dàng. Dùng nóng với rau và thêm chút chanh tùy thích."
      ],
      "tips": ["Chọn các miếng cá có độ dày tương đương.", "Thời gian trong bản thảo là tham khảo; kiểm tra độ chín trước khi dùng."]
    },
    {
      "slug": "sinh-to-bo-chuoi", "title": "Sinh tố bơ chuối", "summary": "Bơ béo dịu, chuối chín ngọt tự nhiên. Một ly sinh tố mịn mượt cho buổi sáng thảnh thơi.",
      "image": "/recipe-images/sinh-to-bo-chuoi.png", "imageAlt": "Sinh tố bơ chuối trong ly thủy tinh với bơ và chuối tươi", "illustrative": true,
      "appliance": "blender", "mealType": "drink", "prepMinutes": 5, "cookMinutes": 0, "servings": 2,
      "ingredients": [
        { "amount": "1 quả", "name": "bơ chín" }, { "amount": "1 quả", "name": "chuối chín" }, { "amount": "250 ml", "name": "sữa tươi hoặc sữa thực vật" },
        { "amount": "2 thìa canh", "name": "sữa chua không đường" }, { "amount": "Tùy chọn", "name": "mật ong" }
      ],
      "steps": [
        "Bỏ vỏ, hạt bơ và vỏ chuối. Cắt nhỏ trái cây.",
        "Cho sữa vào cối trước, sau đó thêm bơ, chuối và sữa chua. Không vượt mức tối đa của cối.",
        "Xay theo chế độ phù hợp đến khi mịn. Thêm chút sữa nếu muốn hỗn hợp loãng hơn.",
        "Nếm và thêm mật ong nếu thích. Rót ra ly và thưởng thức ngay."
      ],
      "tips": ["Dùng trái cây và sữa đã làm mát để sinh tố ngon hơn.", "Chỉ xay nguyên liệu đông lạnh hoặc đá nếu máy của bạn hỗ trợ."]
    },
    {
      "slug": "banh-mi-bo-toi", "title": "Bánh mì bơ tỏi", "summary": "Vỏ giòn, ruột mềm, thơm bơ tỏi. Món ăn nhẹ dễ làm cho những buổi chiều ở nhà.",
      "image": "/recipe-images/banh-mi-bo-toi.png", "imageAlt": "Bánh mì bơ tỏi nướng vàng với rau mùi tây", "illustrative": true,
      "appliance": "oven", "mealType": "snack", "prepMinutes": 10, "cookMinutes": 8, "servings": 2,
      "ingredients": [
        { "amount": "1 ổ nhỏ", "name": "bánh mì baguette" }, { "amount": "40 g", "name": "bơ mềm" }, { "amount": "2 tép", "name": "tỏi băm" },
        { "amount": "1 thìa canh", "name": "mùi tây băm" }, { "amount": "Một ít", "name": "muối" }
      ],
      "steps": [
        "Làm nóng lò ở 180°C theo hướng dẫn thiết bị. Cắt bánh mì thành lát dày khoảng 2 cm.",
        "Trộn bơ mềm với tỏi, mùi tây và một chút muối.",
        "Phết hỗn hợp lên từng lát bánh, xếp một lớp trên khay nướng.",
        "Nướng khoảng 6–8 phút đến khi viền bánh vàng giòn. Theo dõi để tỏi không bị cháy. Dùng khi còn ấm."
      ],
      "tips": ["Phết bơ đều và không quá dày.", "Có thể thêm phô mai nếu thích; kiểm tra thành phần theo nhu cầu của bạn."]
    },
    {
      "slug": "chao-bi-do", "title": "Cháo bí đỏ", "summary": "Một bát cháo sánh nhẹ, vị bí đỏ dịu ngọt, cho bữa sáng ấm áp và thong thả.",
      "image": "/recipe-images/chao-bi-do.png", "imageAlt": "Bát cháo bí đỏ màu vàng ấm với hành lá", "illustrative": true,
      "appliance": "rice-cooker", "mealType": "breakfast", "prepMinutes": 10, "cookMinutes": 40, "servings": 2,
      "ingredients": [
        { "amount": "80 g", "name": "gạo" }, { "amount": "200 g", "name": "bí đỏ" }, { "amount": "Theo hướng dẫn nồi", "name": "nước nấu cháo" },
        { "amount": "1 thìa cà phê", "name": "dầu ăn" }, { "amount": "Một ít", "name": "muối, hành lá" }
      ],
      "steps": [
        "Vo gạo. Gọt vỏ bí đỏ, bỏ hạt và cắt hạt lựu.",
        "Cho gạo, bí đỏ và nước vào nồi. Tuân theo mức nước dành riêng cho chế độ cháo để tránh trào.",
        "Chọn chế độ cháo theo hướng dẫn thiết bị, nấu đến khi gạo nở mềm và bí đỏ chín.",
        "Khuấy nhẹ, thêm dầu ăn và nêm vừa miệng. Điều chỉnh độ sánh bằng nước nóng nếu cần. Thêm hành lá khi dùng."
      ],
      "tips": ["Chỉ dùng chế độ cháo nếu nồi của bạn hỗ trợ.", "Mở nắp cẩn thận để tránh hơi nóng."]
    },
    {
      "slug": "sot-pesto-hung-que", "title": "Sốt pesto húng quế", "summary": "Hương húng quế tươi và vị béo của hạt điều, để món mì hay bánh mì quen thuộc thêm thú vị.",
      "image": "/recipe-images/sot-pesto-hung-que.png", "imageAlt": "Sốt pesto húng quế tươi trong bát sứ bên nguyên liệu", "illustrative": true,
      "appliance": "blender", "mealType": "side", "prepMinutes": 10, "cookMinutes": 0, "servings": 4,
      "ingredients": [
        { "amount": "40 g", "name": "lá húng quế" }, { "amount": "30 g", "name": "hạt điều rang không muối" }, { "amount": "50 ml", "name": "dầu ô liu" },
        { "amount": "20 g", "name": "phô mai Parmesan" }, { "amount": "1 tép", "name": "tỏi" }, { "amount": "Một ít", "name": "nước cốt chanh, muối" }
      ],
      "steps": [
        "Rửa sạch húng quế và để thật ráo. Bóc vỏ tỏi, chuẩn bị các nguyên liệu.",
        "Cho dầu ô liu, húng quế, hạt điều, tỏi và phô mai vào cối phù hợp với lượng nguyên liệu nhỏ.",
        "Xay nhấp theo hướng dẫn máy để hỗn hợp hòa quyện nhưng vẫn còn chút kết cấu. Dừng máy trước khi vét thành cối.",
        "Nêm thêm nước cốt chanh và muối tùy thích. Dùng ngay với mì đã nấu chín hoặc bánh mì."
      ],
      "tips": ["Công thức có hạt điều và sản phẩm từ sữa.", "Nếu máy không hỗ trợ xay lượng nhỏ, chuẩn bị lượng phù hợp theo hướng dẫn thiết bị."]
    }
  ]
}
